<template>
  <div class="relative z-10">
    <div
      ref="header"
      class="
        flex
        text-orange-100
        items-center
        bg-orange-600
        h-12
        justify-between
        px-4
      "
    >
      <div class="flex items-center h-full">
        <div
          class="h-full flex items-center border-r border-orange-500"
          ref="logo"
        >
          <img
            class="h-8 pr-4"
            src="../../../assets/imgs/logo.png"
            alt="Logo"
          />
        </div>
        <div
          class="h-full flex items-center px-4 border-r border-orange-500"
          ref="workspace"
        >
          <span class="uppercase"> GUATEMALA </span>
        </div>
        <ul class="list-reset flex h-full items-center overflow-hidden">
          <li
            v-for="(menu, k) in options"
            v-bind:key="k"
            class="
              h-full
              flex
              items-center
              justify-center
              px-2
              cursor-pointer
              hover:text-orange-100 hover:font-semibold
            "
            :class="{
              'text-orange-100': isMenuActive(menu),
              'text-orange-400': !isMenuActive(menu),
              'font-semibold': isMenuActive(menu),
            }"
            @click.stop="clickMenu(menu)"
          >
            <i class="mr-1 fas" :class="`el-icon-fa-${menu.icon}`"></i>
            <span>{{ menu.name }}</span>
            <div
              class="absolute arrow-up bottom-0"
              v-if="isMenuActive(menu)"
            ></div>
          </li>
        </ul>
      </div>
      <div class="flex justify-center content-center items-center min">
        <img
          class="w-8 h-8 rounded-full mr-3 border-2 border-orange-200"
          :src="avatar($store.getters.userSex)"
          alt="Gerson E. Aguirre"
        />
        <el-dropdown trigger="click" size="medium">
          <span class="el-dropdown-link text-orange-100">
            <span class="mr-2">{{ $store.getters.shortName }}</span>
            <i class="el-icon-fa-angle-down"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <i class="el-icon-fa-sliders"></i>
              <span>Mi Perfil</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="processLogout" divided>
              <i class="el-icon-fa-sign-out"></i>
              <span>Cerrar sesión</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <transition name="el-zoom-in-top">
      <div
        v-show="showSubMenu"
        v-click-outside="onClickOutside"
        class="
          absolute
          px-5
          h-12
          w-full
          flex
          bg-white
          border-b border-orange-300
          items-center
          text-black
          shadow
        "
      >
        <SettingsSM
          v-show="activeSM === '/settings'"
          v-on:clicked="showSubMenu = false"
        />
        <EmployeesSM
          v-show="activeSM === '/employees'"
          v-on:clicked="showSubMenu = false"
        />
        <AccessSM
          v-show="activeSM === '/access'"
          v-on:clicked="showSubMenu = false"
        />
        <ContractsSM
          v-show="activeSM === '/contracts'"
          v-on:clicked="showSubMenu = false"
        />
        <PaysheetSM
          v-show="activeSM === '/paysheet'"
          v-on:clicked="showSubMenu = false"
        />
        <ReportsSM
          v-show="activeSM === '/reports'"
          v-on:clicked="showSubMenu = false"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import { hasModule } from "./../../../utils.js";
import SettingsSM from "./../../Settings/SettingsSM";
import EmployeesSM from "./../../Employees/EmployeesSM";
import AccessSM from "./../../Access/AccessSM";
import ContractsSM from "./../../Contracts/ContractsSM";
import PaysheetSM from "./../../Paysheet/PaysheetSM";
import ReportsSM from "./../../Reports/ReportsSM";

import axios from "axios";
import * as R from "ramda";

import man from "./../../../assets/imgs/man.png";
import woman from "./../../../assets/imgs/woman.png";
import nosex from "./../../../assets/imgs/nosex.png";

export default {
  name: "Header",
  components: {
    SettingsSM,
    EmployeesSM,
    AccessSM,
    ContractsSM,
    PaysheetSM,
    ReportsSM,
  },
  data() {
    return {
      menuOptions: [
        {
          needsProfile: false,
          hasItems: false,
          icon: "dashboard",
          path: "/",
          name: "Escritorio",
        },
        {
          needsProfile: true,
          hasItems: true,
          icon: "file",
          path: "/contracts",
          name: "Contratos",
        },
        {
          needsProfile: true,
          hasItems: true,
          icon: "users",
          path: "/employees",
          name: "Empleados",
        },
        {
          needsProfile: true,
          hasItems: true,
          icon: "calculator",
          path: "/paysheet",
          name: "Nomina",
        },
        {
          needsProfile: true,
          hasItems: true,
          icon: "file-pdf-o",
          path: "/reports",
          name: "Reportes",
        },
        {
          needsProfile: true,
          hasItems: true,
          icon: "cogs",
          path: "/settings",
          name: "Configuraciones",
        },
        {
          needsProfile: true,
          hasItems: true,
          icon: "sign-in",
          path: "/access",
          name: "Accesos",
        },
      ],
      showChangeCompany: false,
      menuSize: 0,
      companies: [
        {
          value: "Holis",
          label: "holis",
        },
      ],
      value: "",
      value1: "",
      showSubMenu: false,
      activeSM: null,
      currentCompany: "",
    };
  },
  computed: {
    options() {
      return this.menuOptions.filter(
        (item) =>
          this.$store.getters.isSuper ||
          !item.needsProfile ||
          hasModule(item.name)
      );
    },
  },
  methods: {
    onClickOutside() {
      if (this.showSubMenu) {
        this.showSubMenu = false;
      }
    },
    clickMenu({ hasItems, path }) {
      this.showSubMenu = false;
      if (hasItems) {
        this.activeSM = path;
        this.showSubMenu = true;
      } else {
        this.activeSM = null;
        this.$router.push(path);
      }
    },
    isMenuActive({ path }) {
      const rpath = this.$route.path;
      return (
        (rpath.includes(path) && path !== "/") ||
        (rpath === "/" && path === "/")
      );
    },
    processLogout() {
      this.$confirm("¿Estás seguro que deseas cerrar sesión?", "Confirmación", {
        confirmButtonText: "Si, porfavor",
        cancelButtonText: "Cancelar",
        type: "warning",
      }).then(() => {
        this.$store.commit("processLogout");
        this.$router.push("/");
      });
    },
    avatar(sex) {
      switch (sex) {
        case 1:
          return man;
          break;
        case 2:
          return woman;
          break;
        default:
          return nosex;
          break;
      }
    },
    cancelChangeCompany() {
      this.currentCompany = this.$store.getters.activeCompany.id;
      this.showChangeCompany = false;
    },
    changeWorkSpace(newCompany) {
      this.$confirm(
        "¿Estás seguro que deseas cambiar de empresa?",
        "Confirmación",
        {
          confirmButtonText: "Si, cambiar",
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";
              axios
                .post("/", {
                  query: `
                    mutation { 
                      changeWorkSpace
                      ( company: "${newCompany}" )
                      {
                        token
                        user {
                          id
                          email
                          changePassword
                          names
                          lastnames
                          isActive
                          avatarURL
                          super
                        }
                      }
                    }`,
                })
                .then((res) => {
                  const { data, errors } = res.data;
                  if (!R.isNil(data)) {
                    this.$store.commit("createSession", data.changeWorkSpace);
                    location.reload();
                  } else {
                    this.loginMessage = errors[0].message;
                  }
                });
            } else {
              done();
            }
          },
        }
      );
    },
  },
};
</script>

<style lang="postcss" scoped>
.arrow-up {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid white;
}
</style>
